module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('h3', [_c('strong', [_vm._v("Update Insurance Policy Information")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "account-box"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Insurance Provider: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.providerName),
      expression: "providerName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputName"
    },
    domProps: {
      "value": (_vm.providerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.providerName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Policyholder's Name: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.policyName),
      expression: "policyName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputName"
    },
    domProps: {
      "value": (_vm.policyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.policyName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Policy No: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.policyNumber),
      expression: "policyNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputPassword"
    },
    domProps: {
      "value": (_vm.policyNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.policyNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address on Policy: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressOnPolicy),
      expression: "addressOnPolicy"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "address"
    },
    domProps: {
      "value": (_vm.addressOnPolicy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressOnPolicy = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Agent Name: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agentName),
      expression: "agentName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputName"
    },
    domProps: {
      "value": (_vm.agentName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.agentName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Agent Phone No.: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agentPhone),
      expression: "agentPhone"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputName"
    },
    domProps: {
      "value": (_vm.agentPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.agentPhone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Please select the number of vehicles on this policy(Max 5): ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.noVehicles),
      callback: function($$v) {
        _vm.noVehicles = $$v
      },
      expression: "noVehicles"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h3', [_vm._v("Add Vehicles on Insurance Policy")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.noVehicles), function(ind) {
    return _c('section', [_c('div', {
      staticClass: "form-group"
    }, [_c('p', [_c('strong', [_vm._v("Please select the Make and Model of Vehicle " + _vm._s(ind) + ":")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Make")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": "Make"
      },
      on: {
        "change": function($event) {
          return _vm.updateModelDropdown(ind - 1)
        }
      },
      model: {
        value: (_vm.vehicleList[ind - 1].makeValue),
        callback: function($$v) {
          _vm.$set(_vm.vehicleList[ind - 1], "makeValue", $$v)
        },
        expression: "vehicleList[ind -1].makeValue"
      }
    }, _vm._l((_vm.makeOptions), function(item) {
      return _c('el-option', {
        key: item.brand,
        attrs: {
          "label": item.brand,
          "value": item.brand
        }
      })
    }), 1), _vm._v(" "), _c('h4', [_vm._v("Model")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": "Model",
        "disabled": _vm.modelOptions.length === 0
      },
      model: {
        value: (_vm.vehicleList[ind - 1].modelValue),
        callback: function($$v) {
          _vm.$set(_vm.vehicleList[ind - 1], "modelValue", $$v)
        },
        expression: "vehicleList[ind -1].modelValue"
      }
    }, _vm._l((_vm.modelOptions[ind - 1]), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    }), 1), _vm._v(" "), _c('h4', [_vm._v("Year")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": "Year"
      },
      model: {
        value: (_vm.vehicleList[ind - 1].yearValue),
        callback: function($$v) {
          _vm.$set(_vm.vehicleList[ind - 1], "yearValue", $$v)
        },
        expression: "vehicleList[ind -1].yearValue"
      }
    }, _vm._l((_vm.yearOptions), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    }), 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
      attrs: {
        "for": "inputPassword"
      }
    }, [_vm._v("Vehicle's VIN: ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.vehicleList[ind - 1].vinNumber),
        expression: "vehicleList[ind -1].vinNumber"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "inputPassword"
      },
      domProps: {
        "value": (_vm.vehicleList[ind - 1].vinNumber)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.vehicleList[ind - 1], "vinNumber", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('br'), _vm._v("\n                                and/or\n                                "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
      attrs: {
        "for": "inputPassword"
      }
    }, [_vm._v("License Plate No.: ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.vehicleList[ind - 1].licensePlateNumber),
        expression: "vehicleList[ind -1].licensePlateNumber"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "inputPassword"
      },
      domProps: {
        "value": (_vm.vehicleList[ind - 1].licensePlateNumber)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.vehicleList[ind - 1], "licensePlateNumber", $event.target.value)
        }
      }
    })], 1), _vm._v(" "), _c('hr')])
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 row-block"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.saveChanges
    }
  }, [_vm._v("Save Changes")])]), _vm._v(" "), _c('hr')])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37f82ffa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditPolicy.vue
// module id = 1286
// module chunks = 2